import { formatCompactNumber } from '@occc-app/lib/numbers';

export const tickFormatter = (value: number) => formatCompactNumber(value, 0);

export const roundNumberToTwoDecimals = (number: number): string => number.toFixed(2);
